import React, { useEffect } from 'react';
import LayerPopUp from 'components/atoms/LayerPopUp';

import { Btn } from 'components';
import { BUTTON_CONFIRM } from 'commons/ZimssaString';
import { usePopup } from 'hooks';

export interface Props {
    isMaintenance: boolean;
    contentText: string;
}

function PopupMaintenance({ isMaintenance, contentText }: Props): React.ReactElement {
    const { isShow, popupAction } = usePopup();

    useEffect(() => {
        if (isMaintenance) {
            popupAction();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMaintenance]);
    const LayerPopUpProps = {
        width: 485,
        isShow: isShow,
        noTitle: true,
        onClickPopupAction: popupAction,
        buttons: (
            <Btn
                height={64}
                color={'gray_opacity_50'}
                backGroundColor={'blue_900'}
                fontStyle={'body1_blod'}
                onClick={() => {
                    popupAction();
                }}
            >
                {BUTTON_CONFIRM}
            </Btn>
        ),
        labelProps: {
            fontStyle: 'title_bold',
            color: 'gray_opacity_800',
        },
    };

    return (
        <LayerPopUp {...LayerPopUpProps}>
            <div dangerouslySetInnerHTML={{ __html: contentText }}></div>
        </LayerPopUp>
    );
}

export default PopupMaintenance;
